"use client";
/*
 * Documentation:
 * DC_Excursion_Actions — https://app.subframe.com/4f62853ee923/library?component=DC_Excursion_Actions_d829c949-f459-4689-8d70-67fac82b1b07
 * DC_Excursion_Intro — https://app.subframe.com/4f62853ee923/library?component=DC_Excursion_Intro_ddfba327-58f7-4c9c-b069-378ffe1c6e10
 * Icon Button — https://app.subframe.com/4f62853ee923/library?component=Icon+Button_af9405b1-8c54-4e01-9786-5aad308224f6
 */

import React from "react";
import { FeatherX } from "@subframe/core";
import * as SubframeUtils from "../utils";
import { Dc_Excursion_Actions } from "./Dc_Excursion_Actions";
import { IconButton } from "./IconButton";

interface CloseButtonProps extends React.ComponentProps<typeof IconButton> {
  className?: string;
}

const CloseButton = React.forwardRef<
  React.ElementRef<typeof IconButton>,
  CloseButtonProps
>(function CloseButton({ className, ...otherProps }: CloseButtonProps, ref) {
  return (
    <IconButton
      className={className}
      variant="neutral-primary"
      size="large"
      icon={<FeatherX />}
      ref={ref}
      {...otherProps}
    />
  );
});

interface Dc_Excursion_IntroRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  closeSlot?: React.ReactNode;
  breadcrumbsSlot?: React.ReactNode;
  overlineSlot?: React.ReactNode;
  headingSlot?: React.ReactNode;
  className?: string;
}

const Dc_Excursion_IntroRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Excursion_IntroRootProps
>(function Dc_Excursion_IntroRoot(
  {
    closeSlot,
    breadcrumbsSlot,
    overlineSlot,
    headingSlot,
    className,
    ...otherProps
  }: Dc_Excursion_IntroRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex w-full flex-col items-start gap-12",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <Dc_Excursion_Actions
        breadcrumbsSlot={
          breadcrumbsSlot ? (
            <div className="flex items-start justify-between">
              {breadcrumbsSlot}
            </div>
          ) : null
        }
        closeSlot={
          closeSlot ? (
            <div className="flex items-start justify-between">{closeSlot}</div>
          ) : null
        }
      />
      <div className="flex flex-col items-start gap-1">
        {overlineSlot ? (
          <div className="flex flex-col items-start gap-1">{overlineSlot}</div>
        ) : null}
        {headingSlot ? (
          <div className="flex flex-col items-start gap-1">{headingSlot}</div>
        ) : null}
      </div>
    </div>
  );
});

export const Dc_Excursion_Intro = Object.assign(Dc_Excursion_IntroRoot, {
  CloseButton,
});
